import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { AuthProvider } from "./hooks/useAuth";
import ScrollTop from "./components/feature/ScrollTop";


function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollTop />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;